import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-height: min(80vh, 500px);
`;

export const formPacketListContainerStyle = css`
  margin-top: ${theme.spacing(2)};
  flex: 1;
  overflow: auto;
`;
